module.exports = __webpack_public_path__ + "img/box21.bf52fec3.png";